import Vue from 'vue'
import Router from 'vue-router'
const VueRouterPush = Router.prototype.push
const isDevelopment = process.env.NODE_ENV === 'development'
const modeType = isDevelopment?'hash':'history'

Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
Vue.use(Router)

export default new Router({
  mode: modeType,
  routes: [
    {
      path: '/',
      name: 'indexPage',
      meta: {
        title: '接龙',
        level: '1'
      },
      component: resolve => require(['@/view/main'], resolve)
    },
    {
      path: '/withdrawal',
      name: 'withdrawal',
      meta: {
        title: '提现列表',
        level: '1'
      },
      component: resolve => require(['@/view/withdrawal'], resolve)
    },
    {
      path: '/myPage',
      name: 'myPage',
      meta: {
        title: '我的',
        level: '1'
      },
      component: resolve => require(['@/view/myPage'], resolve)
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      meta: {
        title: '接龙信息',
        level: '2'
      },
      component: resolve => require(['@/view/orderDetail'], resolve)
    },
    {
      path: '/notFound',
      name: 'notFound',
      meta: {
        title: '暂无权限',
        level: '2'
      },
      component: resolve => require(['@/view/notFound'], resolve)
    },
    {
      path: '/bindLogin',
      name: 'bindLogin',
      meta: {
        title: '绑定手机号',
        level: '2'
      },
      component: resolve => require(['@/view/bindLogin'], resolve)
    },

    {
      path: '/withdrawalApprove',
      name: 'withdrawalApprove',
      meta: {
        title: '提现审核',
        level: '2'
      },
      component: resolve => require(['@/view/withdrawalApprove'], resolve)
    },
    {
      path: '/chargebackApprove',
      name: 'chargebackApprove',
      meta: {
        title: '退单审核',
        level: '2'
      },
      component: resolve => require(['@/view/chargebackApprove'], resolve)
    },
    {
      path: '/blacklist',
      name: 'blacklist',
      meta: {
        title: '黑名单',
        level: '2'
      },
      component: resolve => require(['@/view/blacklist'], resolve)
    },
    {
      path: '/remitlist',
      name: 'remitlist',
      meta: {
        title: '我的打款',
        level: '2'
      },
      component: resolve => require(['@/view/remit'], resolve)
    },
    {
      path: '/authList',
      name: 'authList',
      meta: {
        title: '实名认证审核列表',
        level: '2'
      },
      component: resolve => require(['@/view/authList'], resolve)
    },
    {
      path: '/authCtrl',
      name: 'authCtrl',
      meta: {
        title: '实名认证审核',
        level: '2'
      },
      component: resolve => require(['@/view/authCtrl'], resolve)
    },
    {
      path: '/separateAccounts',
      name: 'separateAccounts',
      meta: {
        title: '添加分账',
        level: '2'
      },
      component: resolve => require(['@/view/separateAccounts'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js